import React from 'react';
import './App.css';
import TelegramMiniApp from './TelegramMiniApp';

function App() {
  return <TelegramMiniApp />;
}

export default App;
